import { getVppnToken } from 'api/axios/vppn';
import { errors_AuthenticationUrl } from 'main/routes/urls/RouteUrls';

import { EmptyProvider } from './Empty';
import { MsalProvider } from './Msal';
import { AuthenticationProvider } from './Provider';
import { AuthProviderStorage } from './Storage';
import { VppnProvider } from './Vppn';
import { VppnReverseProxyType } from 'modules/ServiceProtocol/Components/ServiceProtocolPdf/Types';
import { isMsAppProxy } from '../config';

const defaultProvider = new EmptyProvider();

const initializeAuthProviderStorage = async () => {

	// if current page is authentication error, then there is no point in initializing any authentication provider
	if (window.location.pathname.toLowerCase().indexOf(errors_AuthenticationUrl) > -1) {
		return undefined;
	}

	try {
		const token = await getVppnToken();
		const provider = token ? new VppnProvider(token) : new MsalProvider();
		AuthProviderStorage.initialize(provider);
	}
	catch {
		AuthProviderStorage.initialize(defaultProvider);
	}

	return AuthProviderStorage.getInstance().getProvider();
}


const isVppn = (): boolean =>
	AuthProviderStorage.getInstance().getProvider() instanceof VppnProvider;

const vppnReverseProxyType = (): VppnReverseProxyType | undefined => {

	if (!isVppn()) {
		return undefined;
	}

	if (isMsAppProxy) {
		return 'msappproxy.net';
	}

	return 'securewss';
}


// like isVppn, but waits for AuthProviderStorage initalization
const isVppnAsync = async () => {
	await AuthProviderStorage.getInitializerPromise();
	return isVppn();
}

export {
	initializeAuthProviderStorage,
	isVppn,
	vppnReverseProxyType,
	isVppnAsync,
	AuthenticationProvider,
	AuthProviderStorage,
	EmptyProvider,
	MsalProvider,
	VppnProvider,
};
